import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-auto"
}
const _hoisted_2 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = {
  key: 1,
  class: "text-muted text-capitalize-first"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      (_ctx.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.merchant')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.store')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.pay_in_fee_percent')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.pay_in_reward_fee_type')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.pay_out_fee_percent')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.pay_out_reward_fee_type')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${item.merchantId}-${item.slot}-${item.storeId ?? 'all'}`
                  }, [
                    _createElementVNode("td", null, [
                      (item.isMerchantBlocked)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 0,
                            title: _ctx.helper.trans('labels.user_blocked'),
                            class: "fa fa-ban text-danger me-1"
                          }, null, 8, _hoisted_9)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.merchantName), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (item.storeName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.storeName), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.referral_fees_all_stores')), 1))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(item.payInFee), 1)) + "%", 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${item.payInFeeType}`)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.helper.floatToPercent(item.payOutFee), 1)) + "%", 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`labels.ref_fee_type.${item.payOutFeeType}`)), 1)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.referral_merchant_fees_empty')), 1))
    ]),
    _: 1
  }, 512))
}